// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Rendu generique des pages legales / chartes (contenu HTML issu de pages_du_site).
 * Reprend le style des anciens composants en dur : Arial, interlignage 1.6, titres orange (#f97316),
 * listes a puces disques. Cible les balises brutes injectees (h1..h4, p, ul/li, a) sans classes.
 */
.page-statique-page {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  width: 100%;
  padding: 2rem;
  margin: 0;
}

.page-statique-container {
  max-width: inherit;
  margin: 0;
}

.page-statique-content h1,
.page-statique-content h2,
.page-statique-content h3,
.page-statique-content h4 {
  color: #f97316;
}

.page-statique-content h2 {
  margin-top: 1rem;
}

.page-statique-content h3,
.page-statique-content h4 {
  margin-top: 1.5rem;
}

.page-statique-content p {
  margin-bottom: 1em;
}

.page-statique-content ul {
  list-style-type: disc;
  margin-left: 20px;
  margin-bottom: 1em;
}

.page-statique-content li {
  margin-bottom: 0.25em;
}

.page-statique-content a {
  color: #f97316;
  text-decoration: underline;
}

.page-statique-erreur {
  color: #6b7280;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PageStatique/PageStatique.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB","sourcesContent":["/*\n * Rendu generique des pages legales / chartes (contenu HTML issu de pages_du_site).\n * Reprend le style des anciens composants en dur : Arial, interlignage 1.6, titres orange (#f97316),\n * listes a puces disques. Cible les balises brutes injectees (h1..h4, p, ul/li, a) sans classes.\n */\n.page-statique-page {\n  font-family: Arial, sans-serif;\n  line-height: 1.6;\n  width: 100%;\n  padding: 2rem;\n  margin: 0;\n}\n\n.page-statique-container {\n  max-width: inherit;\n  margin: 0;\n}\n\n.page-statique-content h1,\n.page-statique-content h2,\n.page-statique-content h3,\n.page-statique-content h4 {\n  color: #f97316;\n}\n\n.page-statique-content h2 {\n  margin-top: 1rem;\n}\n\n.page-statique-content h3,\n.page-statique-content h4 {\n  margin-top: 1.5rem;\n}\n\n.page-statique-content p {\n  margin-bottom: 1em;\n}\n\n.page-statique-content ul {\n  list-style-type: disc;\n  margin-left: 20px;\n  margin-bottom: 1em;\n}\n\n.page-statique-content li {\n  margin-bottom: 0.25em;\n}\n\n.page-statique-content a {\n  color: #f97316;\n  text-decoration: underline;\n}\n\n.page-statique-erreur {\n  color: #6b7280;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
